import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";


function AddCity() {
  const [cityName, setCityName] = useState("");

  const handleSubmit = async () => {
    if (!cityName.trim()) {
      alert("Please enter a city name.");
      return;
    }

    try {
      const response = await axios.post(
        "https://visitguru.in/api/v1/city/addCity",
        { cityName }
      );

      if (response.status === 200) {
        toast.success("City added successfully!"); // Success toast
        setCityName(""); // Clear input field after submission
      }
    } catch (error) {
      console.error("Error adding city:", error);
      toast.error("Failed to add city. Please try again."); // Error toast      
    }
  };

  return (
    <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
      <div className="rounded-t bg-white mb-0 px-6 py-6">
        <div className="text-center flex justify-between">
          <h6 className="text-blueGray-700 text-xl font-bold">Add City</h6>
        </div>
      </div>
      <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
        <form onSubmit={(e) => e.preventDefault()}>
          <div className="flex flex-wrap">
            <div className="w-full lg:w-12/12 px-4">
              <div className="relative w-full mb-3">
                <label
                  className="block uppercase text-blueGray-600 text-xs font-bold mb-2 mt-4"
                  htmlFor="city"
                >
                  City
                </label>
                <input
                  type="text"
                  id="city"
                  className="border-0 px-3 py-3 mt-2 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="Enter City"
                  value={cityName}
                  onChange={(e) => setCityName(e.target.value)}
                />
              </div>
            </div>
          </div>

          {/* Button Aligned to Right */}
          <div className="flex justify-end w-full">
            <button
              className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs mt-2 px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
              type="button"
              onClick={handleSubmit}
            >
              Add
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddCity;
